import React, { Component, Fragment } from 'react'
import SearchBar from '../../components/SearchBar'
import analytics from '../../utils/analytics'
import councillors from '../../data/toronto/councillors.json'
import councillorsId from '../../data/toronto/councillorsId.json'
import { Helmet } from 'react-helmet'
import List from 'material-ui/List'
import CouncillorListItem from '../../components/CouncillorListItem'

type State = {
  visibleCouncillors: string[]
}

class TorontoAttendance extends Component<void, State> {
  state = {
    visibleCouncillors: councillorsId
  }

  animate = true

  componentDidMount () {
    analytics.track('Attendance Viewed')
    this.animate = false
  }

  handleSearchChange = value => {
    const query = value && value.toLowerCase()
    const visibleCouncillors = councillorsId
      .filter(councillorId => {
        const councillor = councillors[councillorId]
        return councillor.name.toLowerCase().includes(query) ||
          councillor.title.toLowerCase().includes(query)
      })

    this.setState({
      visibleCouncillors
    })
  }

  render () {
    const { visibleCouncillors } = this.state

    return (
      <Fragment>
        <Helmet>
          <title>Toronto City Council Attendance</title>
          <meta name='description' content='Compare the attendance records of the members of Toronto city council.' />
        </Helmet>

        <SearchBar onChange={this.handleSearchChange} />

        <List>
          {visibleCouncillors && visibleCouncillors.map(
            councillorId => (
              <CouncillorListItem
                key={councillorId}
                animate={this.animate}
                {...councillors[councillorId]}
              />
            )
          )}
        </List>
      </Fragment>
    )
  }
}

export default TorontoAttendance



// WEBPACK FOOTER //
// ./src/containers/TorontoAttendance/TorontoAttendance.js